import { Component, OnInit } from '@angular/core';
import {
    IGetClientSubscriptionTask,
    IGetClientSubscriptionTaskPositions,
    SubscriptionsService,
} from 'app/modules/shared/services/subscriptions.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { forkJoin } from 'rxjs';
import { EmployeePositionService, StaffPosition } from '../../services/employee-position.service';

@Component({
    selector: 'app-subscriptions',
    templateUrl: './subscriptions.component.html',
    styleUrls: ['./subscriptions.component.scss'],
})
export class SubscriptionsComponent implements OnInit {
    constructor(
        private subscriptionsService: SubscriptionsService,
        private employeePosition: EmployeePositionService
    ) {}
    data: IGetClientSubscriptionTask[];
    gridData: GridDataResult;
    staffPositions: StaffPosition[];
    dropdownListSettings: any = {
        singleSelection: false,
        text: 'Select Positions to receive emails',
        enableSearchFilter: false,
        showCheckbox: true,
        labelKey: 'position',
        primaryKey: 'positionIdentifier',
        enableFilterSelectAll: false,
        enableCheckAll: false,
    };
    positionsSelected: IPositionsData[] = [];
    allPositions: IPositionsData[] = [];
    clientSubscriptionTaskPositions: IGetClientSubscriptionTaskPositions[];
    overallPositionsSelected = {};

    ngOnInit(): void {
        this.loadSubscriptionTasksData();
        this.loadPositionsData();
    }

    loadSubscriptionTasksData() {
        forkJoin([
            this.subscriptionsService.getClientSubscriptionTask(),
            this.subscriptionsService.getSubscriptionTasks(),
        ]).subscribe(
            ([clientSubscriptionData, subscriptionData]) => {
                this.prepareSubscriptionData(clientSubscriptionData, subscriptionData);
                this.prepareGridData();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    prepareSubscriptionData(clientSubscriptionData, subscriptionData) {
        const data = [];
        for (let subscription of subscriptionData) {
            const associatedClientSubscription = clientSubscriptionData.find(
                (i) => i.subscriptionTaskKey === subscription.subscriptionTaskKey
            );
            if (associatedClientSubscription) {
                data.push(associatedClientSubscription);
            } else {
                data.push(subscription);
            }
        }
        this.data = data;
    }

    loadPositionsData() {
        forkJoin([
            this.employeePosition.getPositions(),
            this.subscriptionsService.getClientSubscriptionTaskPositions(),
            this.subscriptionsService.getClientSubscriptionTask(),
        ]).subscribe(
            ([positionsData, clientSubscriptionTaskPositionsData, clientTask]) => {
                this.staffPositions = positionsData;
                this.clientSubscriptionTaskPositions = clientSubscriptionTaskPositionsData;
                if (clientTask.length === 0) {
                    this.preparePositionData(-1);
                }

                for (let task of clientTask) {
                    this.preparePositionData(Number(task.clientSubscriptionTaskKey));
                }
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    savePositionData(event, clientSubscriptionTaskKey: number, isActive: boolean) {
        const params = {
            clientSubscriptionTaskKey,
            staffPositionKey: event.positionIdentifier,
            isActive,
        };
        this.subscriptionsService.upsertClientSubscriptionTaskPosition(params).subscribe(
            () => {},
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    prepareGridData() {
        for (let sub of this.data) {
            sub.dropdownListSettings = JSON.parse(JSON.stringify(this.dropdownListSettings));
            sub.dropdownListSettings.disabled = !sub.hasOwnProperty('isActive');
        }

        this.gridData = {
            data: this.data,
            total: this.data.length,
        };
    }

    preparePositionData(clientKey: number) {
        this.allPositions.length = 0;
        this.positionsSelected.length = 0;
        for (let i = 0; i < this.staffPositions.length; i++) {
            const positionToAdd = {
                position: this.staffPositions[i].position,
                positionIdentifier: this.staffPositions[i].staffPositionKey,
            };
            this.allPositions.push(positionToAdd);
            for (let clientSubTaskPosition of this.clientSubscriptionTaskPositions) {
                if (
                    clientSubTaskPosition.staffPositionKey ===
                        this.staffPositions[i].staffPositionKey &&
                    clientSubTaskPosition.isActive &&
                    clientSubTaskPosition.clientSubscriptionTaskKey === clientKey
                ) {
                    this.positionsSelected.push(positionToAdd);
                }
            }
        }

        this.overallPositionsSelected[clientKey] = JSON.parse(
            JSON.stringify(this.positionsSelected)
        );
    }

    toggleTask(record) {
        const params = {
            subscriptionTaskKey: record.subscriptionTaskKey,
            isActive: record.isActive,
        };
        this.subscriptionsService.upsertClientSubscriptionTask(params).subscribe(
            () => {
                this.loadSubscriptionTasksData();
            },
            (error) => {
                console.log('error: ', error);
            }
        );
    }

    onSelectPosition(event, clientSubscriptionTaskKey: number) {
        this.savePositionData(event, clientSubscriptionTaskKey, true);
    }

    onDeselectPosition(event, clientSubscriptionTaskKey: number) {
        this.savePositionData(event, clientSubscriptionTaskKey, false);
    }
}

export interface IPositionsData {
    position: string;
    positionIdentifier: number;
}
